import { render } from "./App.vue?vue&type=template&id=b8999ab4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b8999ab4&lang=less"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__